export type SlideManifestPair = { slideId1: string; slideId2: string };

export interface RunSlideRegistrationsFormValues {
  jobName: string;
  jobDescription: string;
  slideManifest: SlideManifestPair[];
  // UI-only slide metadata filters
  sourceStain: string;
  targetStain: string;
  sourceNegativeControl?: boolean;
  targetNegativeControl?: boolean;
}

export enum RunSlideRegistrationsStep {
  SelectSlides = 'Select Slides',
  NameAndDescription = 'Name and Description',
}

export const runSlideRegistrationsOrder = [
  RunSlideRegistrationsStep.SelectSlides,
  RunSlideRegistrationsStep.NameAndDescription,
];
